import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
import {
  RefreshCcw,
  RotateCw,
  ShoppingCart,
} from "feather-icons-react/build/IconComponents";
import { Check, Trash2 } from "react-feather";
import Select from "react-select";
import PlusCircle from "feather-icons-react/build/IconComponents/PlusCircle";
import MinusCircle from "feather-icons-react/build/IconComponents/MinusCircle";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  API_BASE_URL,
  INSERT_ORDERS,
  GET_CATEGORIES_ITEMS,
  GET_VSTORE_PROD,
  GET_TAXES_DATA,
  GET_PAYMENTS_TYPES,
  IMAGE_URL_IBIZ,
  GET_CUSTOMERS,
} from "../../Config";
import Axios from "axios";
import AllCategoryImage from "./categories.png";
// import AddCustomerModal from "../../core/modals/peoples/AddCustomerModal";
import AddCustomerModal from "./Addcustomermodal";
import SpinLoader from "../loader/SpinLoader";
import { useReactToPrint } from "react-to-print";

const AddSale = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const [categoriesData, setCategoriesData] = useState([]);
  const [catLoadingData, setCatLoadingData] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [productsDDL, setProductsDDL] = useState([]);
  const [taxesData, setTaxesData] = useState([]);
  const [selectedCatId, setSelectedCatId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCusId, setSelectedCusId] = useState(null);
  const [customersDDL, setCustomersDDL] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentType, setSelectedPaymentType] = useState(null);
  const [selectedDisType, setSelectedDisType] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountPerc, setDiscountPerc] = useState(0);
  const [payments, setPayments] = useState([]);
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState("");
  const navigate = useNavigate();
  const [barcode, setBarcode] = useState("");
  const [scannedBarcode, setScannedBarcode] = useState("");
  const inputRef = useRef(null);
  const timerRef = useRef(null);
  const [isAddCustomerOpen, setIsAddCustomerOpen] = useState(false);
  const [selectedPaymentTypeOption, setSelectedPaymentTypeOption] =
    useState(null);
  const receiptRef = useRef();
  const [receiptHtml, setReceiptHtml] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(12);
  const [availableRewardPoints, setAvailableRewardPoints] = useState(0);
  const [pointsToRedeem, setPointsToRedeem] = useState(0);
  const [discountFromRewards, setDiscountFromRewards] = useState(0);
  const [rewardMessage, setRewardMessage] = useState("");
  const [showRewardSection, setShowRewardSection] = useState(false);
  const [receiptTemplate, setReceiptTemplate] = useState("");
  const [isTemplateLoading, setIsTemplateLoading] = useState(true);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const SESSION_PRODUCTS_KEY = `vstore_products_${userDataSession?.OrgId}_${userDataSession?.StoreId}`;
  const visibleProducts =
    selectedCatId === 0
      ? productsList
      : productsList.filter((p) => p.CategoryId === selectedCatId);
const [storeProductDiscounts, setStoreProductDiscounts] = useState([]);

  useEffect(() => {
    inputRef.current.focus();
  }, []);
  const handleKeyPress = (e) => {
    if (e.key.length === 1) {
      setBarcode((prev) => prev + e.key);
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      console.log("Scanned Barcode:", barcode);
      const localProduct = productsList.find(
        (product) => product.BarCode === barcode,
      );
      if (localProduct) {
        handleProductSelect({
          value: localProduct.Id,
          label: localProduct.ProductName,
          price: localProduct.StorePrice,
          barcode: localProduct.BarCode,
          imagePath: localProduct.ImagePath,
          taxId: localProduct.TaxId,
          inclusive: localProduct.PriceInclusiveTax,
        });
      } else {
        alert("Product not found for scanned barcode.");
      }
      setBarcode("");
      setScannedBarcode(barcode);
    }, 300);
  };


  useEffect(() => {
  if (!userDataSession?.OrgId || !userDataSession?.StoreId) return;

  const fetchDiscounts = async () => {
    try {
      const res = await Axios.get(
        `${API_BASE_URL}Settings/GetStoreProdDiscount?OrgId=${userDataSession.OrgId}&StoreId=${userDataSession.StoreId}&ProductId=0`
      );
      if (res.data?.Status) {
        setStoreProductDiscounts(res.data.ResultData || []);
      }
    } catch (err) {
      console.warn("Could not load product-specific discounts", err);
    }
  };

  fetchDiscounts();
}, [userDataSession?.OrgId, userDataSession?.StoreId]);

const getAutoDiscountForItem = (cartItem) => {
  // Find all rules for this product
  const rules = storeProductDiscounts.filter(
    (rule) => rule.ProductId === cartItem.value && rule.IsActive
  );

  if (rules.length === 0) return 0;

  let maxDiscount = 0;

  for (const rule of rules) {
    const now = new Date();
    const from = new Date(rule.FromDate);
    const to   = new Date(rule.ToDate);

    if (now < from || now > to) continue;

    // Check minimum quantity
    if (cartItem.quantity < rule.Quantity) continue;

    // Check minimum line value (before discount)
    const lineTotalBeforeDisc = cartItem.price * cartItem.quantity;
    if (lineTotalBeforeDisc < rule.MinProductValue) continue;

    let thisDiscount = 0;

    if (rule.IsPercentage) {
      thisDiscount = (rule.Value / 100) * lineTotalBeforeDisc;
    } else {
      // Fixed discount — most common in your sample
      thisDiscount = rule.Value;
    }

    // Respect max cap
    thisDiscount = Math.min(thisDiscount, rule.MaxDiscountValue || Infinity);

    if (thisDiscount > maxDiscount) {
      maxDiscount = thisDiscount;
    }
  }

  return parseFloat(maxDiscount.toFixed(2));
};

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession?.OrgId}&CustomerId=0`,
      )
        .then((response) => {
          if (response.data.Status) {
            // dispatch(setcustomer_data(response.data.ResultData));
            // setData(response.data.ResultData);
            // sessionStorage.setItem(
            //   "filteredDDLData_Customers",
            //   JSON.stringify(response.data.ResultData)
            // );
            setCustomersDDL(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [userDataSession]);
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    // const customersdata = JSON.parse(
    //   sessionStorage.getItem("filteredDDLData_Customers")
    // );
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      // setCustomersDDL(customersdata);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setCatLoadingData(true);
      Axios.get(
        `${API_BASE_URL}${GET_CATEGORIES_ITEMS}?OrgId=${userDataSession.OrgId}`,
      )
        .then((response) => {
          if (response.data.Status) {
            setCatLoadingData(false);
            setCategoriesData(response.data.ResultData);
            setSelectedCatId(response.data.ResultData[0]?.CategoryId || 0);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          setCatLoadingData(false);
          console.error("Error fetching data:", error);
        });
      Axios.get(
        `${API_BASE_URL}${GET_PAYMENTS_TYPES}?OrgId=${userDataSession.OrgId}`,
      )
        .then((response) => {
          if (response.data.Status) {
            const types = response.data.ResultData;
            setPaymentTypes(types);
            const defaultType = types.find((pt) => pt.IsDefault === true);
            if (defaultType) {
              setSelectedPaymentType(defaultType.Id);
              setSelectedPaymentTypeOption({
                value: defaultType.Id,
                label: defaultType.Name,
              });
            }
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`,
      )
        .then((response) => {
          if (response.data.Status) {
            const formattedTaxes = response.data.ResultData.map((tax) => ({
              value: tax.Id,
              label: `GST ${tax.TaxRate}%`,
              rate: tax.TaxRate,
              sgst: tax.SGSTRate,
              cgst: tax.CGSTRate,
              igst: tax.IGSTRate,
            }));
            setTaxesData(formattedTaxes);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession.OrgId]);
  // useEffect(() => {
  //   if (userDataSession && userDataSession.OrgId && userDataSession.UserId) {
  //     setLoading(true);
  //     const requestData = {
  //       OrgId: userDataSession.OrgId,
  //       CategoryId: selectedCatId || 0,
  //       BarCode: "0",
  //       ProductId: 0,
  //       StoreId: userDataSession.StoreId,
  //       IsForSale: 1,
  //       UserId: userDataSession.UserId,
  //       Type: 1,
  //     };
  //     Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
  //       .then((response) => {
  //         if (response.data.Status) {
  //           // setProductsList(response.data.ResultData);
  //           setProductsDDL(response.data.ResultData);
  //           setLoading(false);
  //         } else {
  //           console.error("Error fetching data:", response.data.Message);
  //           setLoading(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching data:", error);
  //         setLoading(false);
  //       });
  //   }
  // }, [ userDataSession.OrgId]);
  // useEffect(() => {
  //   if (
  //     userDataSession &&
  //     userDataSession.OrgId &&
  //     userDataSession.UserId &&
  //     selectedCatId >= 0
  //   ) {
  //     setLoading(true);
  //     const requestData = {
  //       OrgId: userDataSession.OrgId,
  //       CategoryId: selectedCatId || 0,
  //       BarCode: "0",
  //       ProductId: 0,
  //       StoreId: userDataSession?.StoreId,
  //       IsForSale: 1,
  //       UserId: userDataSession?.UserId,
  //       Type: 1,
  //     };
  //     console.log(requestData, "request data to getting products by category");
  //     Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
  //       .then((response) => {
  //         if (response.data.Status) {
  //           setProductsList(response.data.ResultData);
  //           setCurrentPage(1);
  //           setLoading(false);
  //         } else {
  //           console.error("Error fetching data:", response.data.Message);
  //           setLoading(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching data:", error);
  //         setLoading(false);
  //       });
  //   }
  // }, [selectedCatId, userDataSession]);

  useEffect(() => {
    if (
      !userDataSession?.OrgId ||
      !userDataSession?.UserId ||
      !userDataSession?.StoreId
    )
      return;

    const cached = sessionStorage.getItem(SESSION_PRODUCTS_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        setProductsList(parsed);
        setProductsDDL(parsed); // same list for dropdown
        console.log("Loaded products from sessionStorage:", parsed.length);
        return; // ← skip fetch if cache exists
      } catch (e) {
        console.warn("Invalid products cache → will refetch", e);
      }
    }

    // No valid cache → fetch full list
    setLoading(true);
    const requestData = {
      OrgId: userDataSession.OrgId,
      CategoryId: 0, // ← important: ask for ALL categories
      BarCode: "0",
      ProductId: 0,
      StoreId: userDataSession.StoreId,
      IsForSale: 1,
      UserId: userDataSession.UserId,
      Type: 1,
    };

    Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
      .then((response) => {
        if (response.data.Status) {
          const allProducts = response.data.ResultData || [];
          setProductsList(allProducts);
          setProductsDDL(allProducts);

          // Save to sessionStorage
          sessionStorage.setItem(
            SESSION_PRODUCTS_KEY,
            JSON.stringify(allProducts),
          );
          console.log("Fetched & cached products:", allProducts.length);
        } else {
          console.error("API error:", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => setLoading(false));
  }, [
    userDataSession?.OrgId,
    userDataSession?.StoreId,
    userDataSession?.UserId,
  ]);

  useEffect(() => {
    const loadTemplate = async () => {
      try {
        const orgId = userDataSession?.OrgId;
        if (!orgId) return;

        const res = await Axios.get(
          `${API_BASE_URL}Product/get-template?OrgId=${orgId}`,
        );

        setReceiptTemplate(res.data); // assuming this returns raw HTML string with ##placeholders##
      } catch (err) {
        console.error("Failed to load receipt template", err);

        // Fallback minimal template
        setReceiptTemplate(`
        <div style="text-align:center; padding:20px; font-family:Arial;">
          <h2>Receipt</h2>
          <p>Order placed successfully</p>
          <p>Thank you!</p>
        </div>
      `);
      } finally {
        setIsTemplateLoading(false);
      }
    };

    if (userDataSession?.OrgId) {
      loadTemplate();
    }
  }, [userDataSession?.OrgId]);

  const refetchCustomers = () => {
    Axios.get(
      `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession.OrgId}&CustomerId=0`,
    ).then((res) => {
      if (res.data.Status) setCustomersDDL(res.data.ResultData || []);
    });
  };
  const discountType = [
    { value: "", label: "Choose" },
    { value: "1", label: "Fixed" },
    { value: "2", label: "Percentage" },
  ];
  const discount = [
    { value: "5", label: "5%" },
    { value: "10", label: "10%" },
    { value: "15", label: "15%" },
    { value: "20", label: "20%" },
    { value: "25", label: "25%" },
    { value: "30", label: "30%" },
  ];

  //   const generateReceiptHTML = (orderNo = "AUTO-GEN") => {
  //   const customer = customersDDL.find(c => c.Id === selectedCusId) || {
  //     Name: "Walk-in Customer",
  //     Mobile: ""
  //   };

  //   const itemsHTML = selectedProducts.map((item, i) => `
  //     <tr>
  //       <td>${i + 1}</td>
  //       <td>${item.label}</td>
  //       <td>${item.quantity}</td>
  //       <td align="right">₹${(item.price * item.quantity).toFixed(2)}</td>
  //     </tr>
  //   `).join("");

  //   const paymentsHTML = payments.map((p, i) => {
  //     const typeName = paymentTypes.find(pt => pt.Id === p.PaymentTypeId)?.Name || "Cash";
  //     return `<p>${i + 1}. ${typeName}: ₹${p.PaidAmount.toFixed(2)}</p>`;
  //   }).join("");

  //   return `
  //     <div style="font-family: 'Courier New', monospace; width: 80mm; margin: 0 auto; font-size: 12px; text-align: center;">
  //       <h3>${userDataSession?.BusinessName || "Your Store"}</h3>
  //       <p>${userDataSession?.StoreName || ""}</p>
  //       <p>${userDataSession?.Address || ""}</p>

  //       <hr style="border-top: 1px dashed #000;">
  //       <h4>RECEIPT</h4>
  //       <p>Order No: <strong>${orderNo}</strong></p>
  //       <p>Date: ${new Date().toLocaleDateString("en-IN")}</p>
  //       <p>Time: ${new Date().toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}</p>
  //       <p>Customer: ${customer.Name}</p>
  //       ${customer.Mobile ? `<p>Mobile: ${customer.Mobile}</p>` : ""}
  //       <hr style="border-top: 1px dashed #000;">
  //       <table width="100%" style="border-collapse: collapse;">
  //         <thead>
  //           <tr style="border-bottom: 1px solid #000;">
  //             <th>#</th>
  //             <th>Item</th>
  //             <th>Qty</th>
  //             <th align="right">Amt</th>
  //           </tr>
  //         </thead>
  //         <tbody>${itemsHTML}</tbody>
  //       </table>
  //       <hr style="border-top: 1px dashed #000;">
  //       <div style="text-align: right;">
  //         <p><strong>Subtotal:</strong> ₹${amounts.subtotal}</p>
  //         ${parseFloat(amounts.totalTax) > 0 ? `<p>Tax:</strong> ₹${amounts.totalTax}</p>` : ""}
  //         ${parseFloat(amounts.totalDiscount) > 0 ? `<p style="color:red;">Discount:</strong> -₹${amounts.totalDiscount}</p>` : ""}
  //         <h4><strong>Grand Total:</strong> ₹${amounts.finalTotal}</h4>
  //       </div>
  //       <hr style="border-top: 1px dashed #000;">
  //       <div>${paymentsHTML || "<p>Payment: Cash</p>"}</div>
  //       <hr style="border-top: 1px dashed #000;">
  //       <p>Thank You! Visit Again</p>
  //       <p style="font-size: 10px; color: #666;">Powered by iBiZAccounts</p>
  //     </div>
  //   `;
  // };

  const generateReceiptHTML = (orderNo = "AUTO-GEN") => {
    if (isTemplateLoading || !receiptTemplate) {
      return "<div>Loading receipt template...</div>";
    }

    const customer = customersDDL.find((c) => c.Id === selectedCusId) || {
      Name: "Walk-in ",
      Mobile: "",
    };

    // Prepare data to replace ##placeholders## in the template
    const data = {
      orgname:
        userDataSession?.BusinessName ||
        userDataSession?.OrgName ||
        "Your Store",
      storename: userDataSession?.StoreName || "",
      address: (userDataSession?.Address || "").replace(/\n/g, "<br>"),
      gstin: userDataSession?.GSTIN ? `GSTIN: ${userDataSession.GSTIN}` : "",
      receipttype: "RECEIPT",
      orderno: orderNo,
      orderdate: new Date().toLocaleDateString("en-IN"),
      ordertime: new Date().toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      }),
      customer: customer.Name || "Walk-in",
      customermobile: customer.Mobile || "",
      salesperson: userDataSession?.UserName || "Cashier",
      staffname: userDataSession?.UserName || "Cashier",
      tc: "",

      // Main totals
      subtotal: `₹${amounts.subtotal.toFixed(2)}`,
      tax:
        parseFloat(amounts.totalTax) > 0
          ? `₹${amounts.totalTax.toFixed(2)}`
          : "",
      discount:
        parseFloat(amounts.totalDiscount) > 0
          ? `₹${amounts.totalDiscount.toFixed(2)}`
          : "",
      total: `₹${amounts.finalTotal.toFixed(2)}`,

      // Tax breakdown – this is what was missing
      sgst:
        parseFloat(amounts.sgstTotal) > 0
          ? `₹${amounts.sgstTotal.toFixed(2)}`
          : "",
      cgst:
        parseFloat(amounts.cgstTotal) > 0
          ? `₹${amounts.cgstTotal.toFixed(2)}`
          : "",
      igst:
        parseFloat(amounts.igstTotal) > 0
          ? `₹${amounts.igstTotal.toFixed(2)}`
          : "",

      // Items table rows
      items: selectedProducts
        .map(
          (item) => `
      <tr>
        <td>${item.label}</td>
        <td>${item.quantity}</td>
        <td>₹${(item.price * item.quantity).toFixed(2)}</td>
      </tr>
    `,
        )
        .join(""),

      // Payments
      payments: payments
        .map((p, i) => {
          const typeName =
            paymentTypes.find((pt) => pt.Id === p.PaymentTypeId)?.Name ||
            "Cash";
          return `<p>${i + 1}. ${typeName}: ₹${p.PaidAmount.toFixed(2)}</p>`;
        })
        .join(""),
      paymentmode: payments
        .map((p) => {
          const typeName =
            paymentTypes.find((pt) => pt.Id === p.PaymentTypeId)?.Name ||
            "Cash";
          return `<p>${typeName}</p>`;
        })
        .join(""),
    };

    let html = receiptTemplate;

    // Replace all ##key## placeholders
    Object.entries(data).forEach(([key, value]) => {
      html = html.replace(new RegExp(`##${key}##`, "g"), value || "");
    });

    // Optional: Hide tax rows if zero (if your template has conditional display)
    html = html.replace(
      /\{\{display_sgst\}\}/g,
      data.sgst ? "table-row" : "none",
    );
    html = html.replace(
      /\{\{display_cgst\}\}/g,
      data.cgst ? "table-row" : "none",
    );
    html = html.replace(
      /\{\{display_igst\}\}/g,
      data.igst ? "table-row" : "none",
    );
    html = html.replace(
      /\{\{display_discount\}\}/g,
      data.discount ? "block" : "none",
    );

    return html;
  };
  const handleDecrement = (index) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product, i) =>
        i === index && product.quantity > 1
          ? { ...product, quantity: product.quantity - 1 }
          : product,
      ),
    );
  };
  const handleIncrement = (index) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product, i) =>
        i === index ? { ...product, quantity: product.quantity + 1 } : product,
      ),
    );
  };
  const settings = {
    dots: true,
    infinite: false,
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 500,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 400,
        settings: { slidesToShow: 1 },
      },
    ],
  };
  const MySwal = withReactContent(Swal);
  const handleDeleteProduct = (index) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.filter((_, i) => i !== index),
    );
  };
  const showConfirmationAlert = (index) => {
    handleDeleteProduct(index);
    // MySwal.fire({
    //   title: "Are you sure?",
    //   text: "You won't be able to revert this!",
    //   showCancelButton: true,
    //   confirmButtonColor: "#00ff00",
    //   confirmButtonText: "Yes, delete it!",
    //   cancelButtonColor: "#ff0000",
    //   cancelButtonText: "Cancel",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     handleDeleteProduct(index);
    //     MySwal.fire({
    //       title: "Deleted!",
    //       text: "The product has been deleted.",
    //       confirmButtonText: "OK",
    //       customClass: { confirmButton: "btn btn-success" },
    //     });
    //   } else {
    //     MySwal.close();
    //   }
    // });
  };
  const getFirstLetter = (str) => {
    const match = str.match(/[a-zA-Z]/);
    return match ? match[0].toUpperCase() : "N/A";
  };

  const handleClearAllProducts = () => {
    if (selectedProducts.length === 0) {
      // Swal.fire({
      //   title: "Info",
      //   text: "No products to clear.",

      //   icon: "info",
      // });
      return;
    }
    MySwal.fire({
      title: "Are you sure?",
      text: "Do you want to clear all products?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, clear all!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setSelectedProducts([]);
        setSelectedDisType(null);
        setDiscountPerc(null);
        setDiscountAmount(null);
        MySwal.fire({
          title: "Cleared!",
          text: "All products have been cleared.",
          confirmButtonText: "OK",
          customClass: { confirmButton: "btn btn-success" },
        });
      } else {
        MySwal.close();
      }
    });
  };
  const handleVoidScreen = () => {
    setSelectedProducts([]);
    setSelectedDisType(null);
    setDiscountPerc(null);
    setDiscountAmount(null);
    setSelectedCusId(null);
    setPayments([]);
    setCurrentPaymentAmount("");
  };

  const handleCustomerSelect = async (selectedOption) => {
    setSelectedCusId(selectedOption.value);
    setPointsToRedeem(0);
    setDiscountFromRewards(0);
    setShowRewardSection(false);
    setRewardMessage("");

    if (!selectedOption?.value || !userDataSession?.OrgId) return;

    try {
      setLoading(true);
      const res = await Axios.get(
        `${API_BASE_URL}Customer/getAllCustPoints?OrgId=${userDataSession.OrgId}`,
      );

      if (res.data?.ResultData?.length > 0) {
        const cust = res.data.ResultData.find(
          (c) => c.CustomerId === selectedOption.value,
        );
        if (cust) {
          const points = Number(cust.AvailablePoints) || 0;
          setAvailableRewardPoints(points);
          setShowRewardSection(points > 0);
          setRewardMessage(points > 0 ? "" : "No reward points available.");
         
          // if (points > 0) await fetchRewardPreview(points);

          if (points > 0) {
  setPointsToRedeem(points); 
  fetchRewardPreview(points); 
}
        } else {
          setAvailableRewardPoints(0);
          setRewardMessage("No reward data for this customer.");
        }
      } else {
        setAvailableRewardPoints(0);
        setRewardMessage("No reward points found.");
      }
    } catch (err) {
      console.error("Reward fetch error:", err);
      setRewardMessage("Error loading reward points.");
    } finally {
      setLoading(false);
    }
  };

  const fetchRewardPreview = async (requested = null) => {
    if (!selectedCusId || selectedProducts.length === 0) return;

    const subtotal = selectedProducts.reduce(
      (sum, p) => sum + p.price * p.quantity,
      0,
    );

    try {
      const res = await Axios.get(
        `${API_BASE_URL}Customer/GetRedeemablePoints`,
        {
          params: {
            OrgId: userDataSession.OrgId,
            CustomerId: selectedCusId,
            TotalAmount: subtotal.toFixed(2),
            RequestedPoints: requested || null,
          },
        },
      );

      if (res.data && res.data.length > 0) {
        const data = res.data[0];
        setDiscountFromRewards(Number(data.DiscountAmount) || 0);
        setPointsToRedeem(Number(data.RedeemablePoints) || 0);
        setAvailableRewardPoints(Number(data.AvailablePoints) || 0);
      }
    } catch (err) {
      console.error("Reward preview failed:", err);
    }
  };

  const handleProductSelect = (product) => {
    setSelectedProducts((prevProducts) => {
      const existingProduct = prevProducts.find(
        (p) => p.barcode === product.barcode && p.value === product.value,
      );
      console.log("existingProduct:", existingProduct);
      if (existingProduct) {
        return prevProducts.map((p) =>
          p.barcode === product.barcode && p.value === product.value
            ? { ...p, quantity: p.quantity + 1 }
            : p,
        );
      } else {
        return [
          ...prevProducts,
          {
            ...product,
            quantity: 1,
            price: product.price,
            barcode: product.barcode,
            id: product.id,
            imagePath: product.imagePath,
          },
        ];
      }
    });
  };
  const styles = {
    imagePlaceholder: {
      width: "3rem",
      height: "3rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      fontSize: "20px",
      color: "#fff",
      backgroundColor: "#FF9F43",
    },
    productImage: {
      width: "3rem",
      height: "3rem",
      objectFit: "cover",
    },
    productInfo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
      minHeight: "4rem",
      paddingLeft: "10px",
    },
    barcodeText: {
      fontSize: "0.85rem",
      color: "#FFFFFF",
      fontWeight: "900",
    },
    productTitle: {
      margin: 0,
      fontSize: "13px",
      fontWeight: "bold",
    },
    productPrice: {
      margin: 0,
      fontSize: "12px",
      // color: '#333',
    },
  };
  const handlePaymentTypeChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedPaymentType(selectedOption.value);
      setSelectedPaymentTypeOption(selectedOption);
    } else {
      setSelectedPaymentType(null);
      setSelectedPaymentTypeOption(null);
    }
  };

  const handleDiscountTypeChange = (selectedOption) => {
    setSelectedDisType(selectedOption.value);
  };
  const handleDiscountPercChange = (selectedOption) => {
    setDiscountPerc(selectedOption.value);
  };
  // region function caluclate amounts
  const getDefaultTax = () => {
    return taxesData.find((tax) => tax.isDefault === true) || taxesData[0]; // fallback to first if none marked default
  };

  // Updated calculateAmounts function
const calculateAmounts = () => {
  let subtotalExclAutoDisc = 0;
  let autoDiscountTotal    = 0;
  let manualDiscount       = 0;
  let totalTax             = 0;
  let sgstTotal = 0, cgstTotal = 0, igstTotal = 0;

  const lineDiscounts = []; // optional – for UI

  selectedProducts.forEach((product) => {
    const lineGross = product.price * product.quantity;

    // ─── 1. Auto discount per line ────────────────────────
    const autoDiscThisLine = getAutoDiscountForItem(product);
    autoDiscountTotal += autoDiscThisLine;

    const lineAfterAutoDisc = lineGross - autoDiscThisLine;

    // Save for UI if you want to show per-item discount
    lineDiscounts.push({
      productId: product.value,
      autoDiscount: autoDiscThisLine,
    });

    // ─── 2. Tax calculation (on amount after auto discount) ───
    let lineSubExclTax = lineAfterAutoDisc;
    let lineSgst = 0, lineCgst = 0;

    let tax = taxesData.find((t) => t.value === product.taxId) || getDefaultTax();

    if (tax) {
      const totalRate = tax.sgst + tax.cgst;

      if (product.inclusive) {
        lineSubExclTax = lineAfterAutoDisc / (1 + totalRate / 100);
        lineSgst = lineSubExclTax * (tax.sgst / 100);
        lineCgst = lineSubExclTax * (tax.cgst / 100);
      } else {
        lineSgst = lineSubExclTax * (tax.sgst / 100);
        lineCgst = lineSubExclTax * (tax.cgst / 100);
      }
    }

    subtotalExclAutoDisc += lineAfterAutoDisc;   // or keep original subtotal?
    totalTax += lineSgst + lineCgst;
    sgstTotal += lineSgst;
    cgstTotal += lineCgst;

    // ─── 3. Manual discount is applied later on subtotal ───
  });

  // Manual discount (your existing logic)
  if (selectedDisType === "1") {
    manualDiscount = parseFloat(discountAmount) || 0;
  } else if (selectedDisType === "2") {
    manualDiscount = ((parseFloat(discountPerc) || 0) / 100) * subtotalExclAutoDisc;
  }

  const taxableAfterManual = subtotalExclAutoDisc - manualDiscount - discountFromRewards;
  const grandTotal = taxableAfterManual + totalTax;

  return {
    subtotal: parseFloat(subtotalExclAutoDisc.toFixed(2)),           // after auto disc
    autoDiscountTotal: parseFloat(autoDiscountTotal.toFixed(2)),
    manualDiscount: parseFloat(manualDiscount.toFixed(2)),
    totalDiscount: parseFloat((autoDiscountTotal + manualDiscount + discountFromRewards).toFixed(2)),
    totalTax: parseFloat(totalTax.toFixed(2)),
    sgstTotal, cgstTotal, igstTotal,
    finalTotal: parseFloat(grandTotal.toFixed(2)),
   
  };
};
  const amounts = calculateAmounts();
  const totalPaid = payments.reduce((sum, p) => sum + p.PaidAmount, 0);
  const remainingAmount = amounts.finalTotal - totalPaid;

  useEffect(() => {
    if (currentPaymentAmount === "") {
      return;
    }
  }, [remainingAmount]);

  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    pageStyle: `
    @page { size: 80mm auto; margin: 0mm; }
    @media print {
      body { margin: 0; padding: 0; font-size: 12px; }
    }
  `,
  });

  const handleSubmit = async () => {
    if (selectedProducts.length === 0 || !selectedCusId) {
      let errors = [];
      if (selectedProducts.length === 0) errors.push("No products selected.");
      // if (!selectedCusId) errors.push("No customer selected.");
      Swal.fire({
        title: "Error",
        text: errors.join(" "),
        icon: "error",
      });
      return;
    }

    const { finalTotal, totalDiscount, sgstTotal, cgstTotal, igstTotal } =
      amounts;

    const requestPayload = {
      orgid: userDataSession?.OrgId,
      userid: userDataSession?.UserId,
      OrgType: 0,
      BillNo: null,
      Order: {
        StoreId: userDataSession?.StoreId,
        PosId: 0,
        OrderType: 1,
        Total: finalTotal,
        Discount: totalDiscount,
        SGST: sgstTotal,
        CGST: cgstTotal,
        IGST: igstTotal,
        Status: 1,
        IsActive: 1,
        Orderdate: new Date().toISOString(),
        DiscountId: 0,
        DiningId: 0,
        ReturnFromOrdId: 0,
        CustomerId: selectedCusId || 0,
        PriceListId: 0,
        TransportMode: "NULL",
        TransportvehicleNumber: "NULL",
        AdditionalCharges: 0,
        AdditionalRoundOffAmount: 0,
        IsAcknowledge: 0,
        TransportAmount: 0,
        InvoiceNo: "NULL",
        EmpId: userDataSession.UserId,
      },
      OrderDetails: selectedProducts.map((prod) => {
        const lineGross = prod.price * prod.quantity;
        let sgst = 0;
        let cgst = 0;
        let igst = 0;
        let sgstrate = 0;
        let cgstrate = 0;
        let igstrate = 0;
        let lineSubExcl = 0;

        let tax = taxesData.find((t) => t.value === prod.taxId);
        if (!tax) {
          tax = getDefaultTax();
        }

        if (tax) {
          const sgstRate = tax.sgst;
          const cgstRate = tax.cgst;
          const totalRate = sgstRate + cgstRate;

          if (prod.inclusive) {
            lineSubExcl = lineGross / (1 + totalRate / 100);
            sgst = lineSubExcl * (sgstRate / 100);
            cgst = lineSubExcl * (cgstRate / 100);
          } else {
            lineSubExcl = lineGross;
            sgst = lineSubExcl * (sgstRate / 100);
            cgst = lineSubExcl * (cgstRate / 100);
          }

          sgstrate = tax.sgst;
          cgstrate = tax.cgst;
          igstrate = tax.igst;
        } else {
          lineSubExcl = lineGross;
        }

        return {
          ProductId: prod.value,
          Quantity: prod.quantity,
          UnitPrice: prod.price,
          Discount: 0,
          SGST: sgst,
          CGST: cgst,
          IGST: igst,
          Total: prod.inclusive ? lineGross : lineSubExcl + sgst + cgst + igst,
          Status: 1,
          RefundQuantity: 0,
          IsActive: 1,
          VendorId: 0,
          IsComplement: 0,
          CGSTrate: cgstrate,
          SGSTrate: sgstrate,
          IGSTrate: igstrate,
          NoOfBags: 0,
          Comments: "",
          ItemWeight: 1,
          ItemPackingWeight: 0,
          BilledBarCode: "NULL",
        };
      }),
      OrderAdditionalDetails: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        MakingCharges: 0,
        OtherCharges: 0,
        MetalRateId: 0,
      })),
      OrderPayments: payments.map((p) => ({
        PaymentTypeId: p.PaymentTypeId,
        PaidAmount: p.PaidAmount,
        CardNo: p.CardNo,
        MobileNo: p.MobileNo,
      })),
      StockHistory: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession?.StoreId || 5,
        StockEffectTypeId: 0,
        StockAdjusted: prod.quantity,
        TransactionId: 0,
        TransfarStockId: 0,
        StockAdjustId: 0,
        IsActive: 1,
        SupplierId: 0,
      })),
      StoreProducts: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession?.StoreId,
        StockAdjusted: -prod.quantity,
      })),
    };

    console.log(requestPayload, "data sending to service...");

    try {
      setIsPlacingOrder(true);
      const response = await Axios.post(
        `${API_BASE_URL}${INSERT_ORDERS}`,
        requestPayload,
      );
      const data = response.data;
      console.log(data, "response data getting from api");

      if (data?.[0]?.OrderId >= 1) {
        const newOrderId = data[0].OrderId;
        const newOrderNo = data[0].OrderNo || "AUTO-GEN";

        if (selectedCusId) {
          try {
            const subtotal = selectedProducts.reduce(
              (sum, p) => sum + p.price * p.quantity,
              0,
            );

            const rewardRes = await Axios.post(
              `${API_BASE_URL}Billing/ProcessRewardPoints`,
              {
                OrgId: userDataSession.OrgId,
                CustomerId: selectedCusId,
                OrderId: newOrderId,
                TotalAmount: amounts.finalTotal,
                SubTotal: subtotal.toFixed(2),
                RedeemedPoints: pointsToRedeem || 0,
                RedeemedAmount: discountFromRewards || 0,
                CreatedBy: userDataSession.UserId,
              },
            );

            console.log("Rewards processed successfully", rewardRes.data);
          } catch (err) {
            console.warn("Reward processing failed:", err);
            Swal.fire({
              title: "Warning",
              text: "Order saved, but reward points could not be processed.",
              icon: "warning",
              timer: 4000,
              toast: true,
              position: "top-end",
            });
          }
        }

        setIsPlacingOrder(false);
        Swal.fire({
          title: "Order Placed Successfully!",
          text: `Order No: ${newOrderNo}`,
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Print Receipt",
          cancelButtonText: "New Bill",
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#6c757d",
        }).then((result) => {
          if (result.isConfirmed) {
            // Generate receipt with the correct order number
            const html = generateReceiptHTML(newOrderNo);

            // Set state
            setReceiptHtml(html);

            // Small delay to ensure React updates the ref before printing
            setTimeout(() => {
              handlePrint();
            }, 300); // 300ms is usually enough for state update & render
          }

          // Always clear form for next order
          setSelectedProducts([]);
          setPayments([]);
          setSelectedDisType(null);
          setDiscountPerc(null);
          setDiscountAmount(null);
          setSelectedCusId(null);
          setAvailableRewardPoints(0);
          setPointsToRedeem(0);
          setDiscountFromRewards(0);
          setShowRewardSection(false);
          setRewardMessage("");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to add order. No valid OrderId returned.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Order creation error:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while adding the order.",
        icon: "error",
      });
    }
  };
  const handleAddPayment = () => {
    let amt = parseFloat(currentPaymentAmount);

    // If input is empty, use the remaining amount as default
    if (isNaN(amt) || currentPaymentAmount === "") {
      amt = remainingAmount;
    }

    if (!paymentType) {
      Swal.fire("Please select a payment type");
      return;
    }

    if (amt <= 0) {
      Swal.fire("Please enter a valid amount");
      return;
    }

    if (amt > remainingAmount) {
      Swal.fire(
        `Amount cannot exceed remaining: ₹${remainingAmount.toFixed(2)}`,
      );
      return;
    }

    const existingIndex = payments.findIndex(
      (p) => p.PaymentTypeId === paymentType,
    );

    if (existingIndex !== -1) {
      const updated = [...payments];
      updated[existingIndex].PaidAmount += amt;
      setPayments(updated);
    } else {
      setPayments([
        ...payments,
        {
          PaymentTypeId: paymentType,
          PaidAmount: amt,
          CardNo: "",
          MobileNo: "",
        },
      ]);
    }

    setCurrentPaymentAmount("");
  };
  const handleRemovePayment = (index) => {
    setPayments(payments.filter((_, i) => i !== index));
  };
  console.log(selectedCatId, "selected cat id");

  return (
    <>
      {isPlacingOrder && <SpinLoader />}
      <div className=" pos-pg-wrapper ms-0">
        <div className="conten pos-design p-0 bg-white">
          <div className="btn-row d-sm-flex align-items-center">
            <Link to="/sales-list" className="btn btn-secondary mb-xs-3">
              <span className="me-1 d-flex align-items-center">
                <ShoppingCart className="feather-16" />
              </span>
              View Orders
            </Link>
            <Link to="#" className="btn btn-info d-none">
              <span className="me-1 d-flex align-items-center">
                <RotateCw className="feather-16" />
              </span>
              Reset
            </Link>
            <Link
              to="#"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#recents"
            >
              <span className="me-1 d-flex align-items-center">
                <RefreshCcw className="feather-16" />
              </span>
              Transaction
            </Link>
            <div className="d-flex col-3" style={{ marginLeft: "10rem" }}>
              <div style={{ position: "relative" }}>
                <i
                  className="fa-solid fa-barcode"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                  }}
                />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Barcode"
                  ref={inputRef}
                  value={scannedBarcode}
                  onKeyPress={handleKeyPress}
                  style={{ paddingLeft: "35px" }}
                />
              </div>
              <button className="btn btn-success ms-1">Submit</button>
            </div>
          </div>
          <div className="row align-items-start pos-wrapper">
            <div className="col-md-12 col-lg-8">
              <div className="pos-categories tabs_wrapper">
                {catLoadingData ? (
                  <SpinLoader />
                ) : (
                  <Slider {...settings}>
                    <div
                      id="all"
                      className="pos-slick-item card m-0"
                      onClick={() => setSelectedCatId(0)}
                    >
                      <div className="card-body text-center">
                        <img
                          src={AllCategoryImage}
                          alt="Category"
                          className="m-auto d-flex text-center "
                          style={{
                            width: "3rem",
                            height: "3rem",
                            borderRadius: "10px",
                          }}
                        />
                        <h6>
                          <Link to="#">All Categories</Link>
                        </h6>
                        <span className="text-info fw-bold">
                          {categoriesData.reduce(
                            (total, category) => total + category.ProductCount,
                            0,
                          )}{" "}
                          Items
                        </span>
                      </div>
                    </div>
                    {categoriesData &&
                      categoriesData.map((item, index) => (
                        <div
                          key={index}
                          className="card pos-slick-item"
                          onClick={() => setSelectedCatId(item.CategoryId)}
                        >
                          <div className="card-body text-center">
                            {item.ImagePath ? (
                              <img
                                src={`${IMAGE_URL_IBIZ}${item.ImagePath}`}
                                alt={item.Name}
                                className="m-auto"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  borderRadius: "10px",
                                  objectFit: "cover",
                                }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div
                              style={{
                                width: "3rem",
                                height: "3rem",
                                borderRadius: "50%",
                                backgroundColor: "#FF9F43",
                                margin: "0 auto 0.5rem",
                                display: item.ImagePath ? "none" : "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#fff",
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                              }}
                            >
                              {getFirstLetter(item.Name)}
                            </div>
                            <h6 title={item.Name}>
                              <Link to="#" className="text-primary">
                                {item.Name.length > 13
                                  ? `${item.Name.substring(0, 13)}...`
                                  : item.Name}
                              </Link>
                            </h6>
                            <span className="text-info fw-semibold">
                              {item.ProductCount} Items
                            </span>
                          </div>
                        </div>
                      ))}
                  </Slider>
                )}
                <div className="pos-products">
                  <div className="d-flex align-items-center justify-content-between my-3">
                    <h5 className="mb-0">Products</h5>
                    <input
                      type="text"
                      className="form-control w-25"
                      placeholder="Search Product..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                  <div className="tabs_container">
                    <div
                      className="tab_content active"
                      data-tab="all"
                      style={{ maxHeight: "90rem", overflowY: "auto" }}
                    >
                      <div className="row">
                        {loading ? (
                          <SpinLoader />
                        ) : (
                          <>
                            {/* Filtered and Paginated Products */}
                            {(() => {
                              const filteredProducts = visibleProducts.filter(
                                (item) =>
                                  item.ProductName.toLowerCase().includes(
                                    searchTerm.toLowerCase(),
                                  ) ||
                                  item.BarCode.toLowerCase().includes(
                                    searchTerm.toLowerCase(),
                                  ),
                              );

                              const indexOfLastProduct =
                                currentPage * productsPerPage;
                              const indexOfFirstProduct =
                                indexOfLastProduct - productsPerPage;
                              const currentProducts = filteredProducts.slice(
                                indexOfFirstProduct,
                                indexOfLastProduct,
                              );

                              const totalPages = Math.ceil(
                                filteredProducts.length / productsPerPage,
                              );

                              return (
                                <>
                                  {/* Products Cards */}
                                  {currentProducts.map((item) => (
                                    <div
                                      className="col-sm-2 col-md-6 col-lg-3 col-xl-3"
                                      key={item.Id}
                                      onClick={() =>
                                        handleProductSelect({
                                          value: item.Id,
                                          label: item.ProductName,
                                          price: item.StorePrice,
                                          barcode: item.BarCode,
                                          imagePath: item.ImagePath,
                                          taxId: item.TaxId,
                                          inclusive: item.PriceInclusiveTax,
                                        })
                                      }
                                    >
                                      <div
                                        className="product-info default-cover card"
                                        style={{ height: "15rem" }}
                                      >
                                        <Link to="#" className="img-bg">
                                          {item.ImagePath ? (
                                            <img
                                              src={`https://pcuploadfiles.azurewebsites.net/download?path=${item.ImagePath}`}
                                              alt="Products"
                                              style={{ height: "6rem" }}
                                            />
                                          ) : (
                                            <div
                                              style={{
                                                width: "70px",
                                                height: "70px",
                                                backgroundColor: "#FF9F43",
                                                marginRight: "10px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "50%",
                                                fontSize: "18px",
                                                color: "#fff",
                                              }}
                                            >
                                              {item
                                                ? getFirstLetter(
                                                    item.ProductName,
                                                  )
                                                : "N/A"}
                                            </div>
                                          )}
                                          <span>
                                            <Check className="feather-16" />
                                          </span>
                                        </Link>
                                        <h6 className="cat-name">
                                          <Link to="#">
                                            {item.BarCode || "Barcode"}
                                          </Link>
                                        </h6>
                                        <h6 className="product-name">
                                          <Link to="#">{item.ProductName}</Link>
                                        </h6>
                                        <div className="d-flex align-items-center justify-content-between price">
                                          <span>{item.StockByUsers} Pcs</span>
                                          <p>₹{item.StorePrice}</p>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                  {/* No products found */}
                                  {filteredProducts.length === 0 &&
                                    searchTerm && (
                                      <div className="col-12 text-center py-5">
                                        <h6>
                                          No products found matching{" "}
                                          {searchTerm}
                                        </h6>
                                      </div>
                                    )}

                                  {/* Pagination Controls */}
                                  {totalPages > 1 && (
                                    <div className="col-12 mt-4">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="text-muted">
                                          Showing {indexOfFirstProduct + 1}-
                                          {Math.min(
                                            indexOfLastProduct,
                                            filteredProducts.length,
                                          )}{" "}
                                          of {filteredProducts.length} products
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <button
                                            className="btn btn-outline-primary btn-sm me-2"
                                            onClick={() =>
                                              setCurrentPage(currentPage - 1)
                                            }
                                            disabled={currentPage === 1}
                                          >
                                            Previous
                                          </button>
                                          <span className="mx-2 fw-bold">
                                            Page {currentPage} of {totalPages}
                                          </span>
                                          <button
                                            className="btn btn-outline-primary btn-sm ms-2"
                                            onClick={() =>
                                              setCurrentPage(currentPage + 1)
                                            }
                                            disabled={
                                              currentPage === totalPages
                                            }
                                          >
                                            Next
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-12 col-lg-4 ps-0"
              style={{ marginTop: "-5rem" }}
            >
              <aside
                className="product-order-list"
                style={{ borderStartEndRadius: "20px" }}
              >
                <div>
                  <div className="d-flex align-items-center mb-3">
                    <div className="flex-grow-1 me-2">
                      <label>Customer</label>
                      <Select
                        options={customersDDL?.map((prod) => ({
                          value: prod.Id,
                          label: prod.Name,
                        }))}
                        className="select"
                        placeholder="Select an customer"
                        onChange={handleCustomerSelect}
                      />
                    </div>

                    <button
                      className="btn btn-primary mt-4"
                      onClick={() => setIsAddCustomerOpen(true)}
                    >
                      <i className="fa-solid fa-user-plus"></i>
                    </button>
                  </div>

                  {/* {showRewardSection && (
                    <div className="block-section mt-3 border-top pt-3">
                      <h6 className="mb-2 d-flex justify-content-between">
                        Reward Points
                        <span className="badge bg-info">
                          {availableRewardPoints.toFixed(0)}
                        </span>
                      </h6>

                      <div className="input-group mb-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Points to redeem"
                          min="0"
                          max={availableRewardPoints}
                          value={pointsToRedeem}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => {
                            let val = parseFloat(e.target.value) || 0;
                            val = Math.min(val, availableRewardPoints);
                            setPointsToRedeem(val);
                            fetchRewardPreview(val);
                          }}
                        />
                        <button
                          className="btn btn-outline-primary"
                          type="button"
                          title="Get Max Redeemable Points"
                          onClick={() => {
                            fetchRewardPreview();
                          }}
                        >
                          Max
                        </button>
                      </div>

                      {discountFromRewards > 0 && (
                        <p className="text-success small mb-2">
                          → ₹{discountFromRewards.toFixed(2)} discount applied
                          <br />
                          Remaining points:{" "}
                          {(availableRewardPoints - pointsToRedeem).toFixed(0)}
                        </p>
                      )}

                      {rewardMessage && (
                        <p className="text-warning small">{rewardMessage}</p>
                      )}
                    </div>
                  )} */}

{showRewardSection && (
  <div className="block-section mt-3 border-top pt-3">
    <h6 className="mb-2 d-flex justify-content-between">
      Reward Points Available
      <span className="badge bg-info">{availableRewardPoints.toFixed(0)}</span>
    </h6>

    <div className="input-group mb-2 position-relative">
      <input
        type="number"
        className="form-control pe-5" // padding for potential future X if needed
        placeholder="Enter points to redeem"
        min="0"
        max={availableRewardPoints}
        value={pointsToRedeem}
        onWheel={(e) => e.target.blur()}
        onChange={(e) => {
          let val = parseFloat(e.target.value) || 0;
          val = Math.min(val, availableRewardPoints);
          setPointsToRedeem(val);
          // Clear old preview when user manually changes input
          setDiscountFromRewards(0);
          setRewardMessage("");
        }}
      />

      {/* Redeem button - triggers Swal */}
      <button
        className="btn btn-outline-primary"
        type="button"
        disabled={pointsToRedeem <= 0 || loading}
        onClick={() => {
          MySwal.fire({
            title: "Confirm Redemption",
            html: `
              <p>Use <strong>${pointsToRedeem.toFixed(0)}</strong> points?</p>
              <p class="small text-muted">This will apply the discount if accepted.</p>
            `,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545",
            confirmButtonText: "OK ",
            cancelButtonText: "Clear",
            reverseButtons: true, 
          }).then((result) => {
            if (result.isConfirmed) {
             
              fetchRewardPreview(pointsToRedeem);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
             
              setPointsToRedeem(0);
              setDiscountFromRewards(0);
              setRewardMessage("");
            }
          });
        }}
      >
        Redeem
      </button>
    </div>

    {/* Preview only after OK/Accept */}
    {discountFromRewards > 0 && pointsToRedeem > 0 && (
      <p className="text-success small mb-2">
        → ₹{discountFromRewards.toFixed(2)} discount applied
        <br />
        Points used: {pointsToRedeem.toFixed(0)} 
        <br />
        Remaining points: {(availableRewardPoints - pointsToRedeem).toFixed(0)}
      </p>
    )}

    {rewardMessage && <p className="text-warning small">{rewardMessage}</p>}
  </div>
)}
                  <div className="col-12 mt-2">
                    <label>Product</label>
                    <Select
                      options={productsDDL?.map((prod) => ({
                        value: prod.Id,
                        label: prod.ProductName,
                        price: prod?.StorePrice,
                        barcode: prod.BarCode,
                        imagePath: prod.ImagePath,
                        taxId: prod.TaxId,
                        inclusive: prod.PriceInclusiveTax,
                      }))}
                      className="select"
                      placeholder="Select an product"
                      onChange={handleProductSelect}
                    />
                  </div>
                </div>
                <div className="product-added block-section">
                  <div className="head-text d-flex align-items-center justify-content-between">
                    <h6 className="d-flex align-items-center mb-0">
                      Products Added
                      <span className="count">{selectedProducts?.length}</span>
                    </h6>
                    <Link
                      to="#"
                      className="d-flex align-items-center text-danger"
                      onClick={handleClearAllProducts}
                    >
                      <span className="me-1">
                        <i data-feather="x" className="feather-16" />
                      </span>
                      Clear all
                    </Link>
                  </div>
                  <div className="product-wrap">
                    {selectedProducts?.map((item, index) => (
                      <div
                        className="product-list d-flex align-items-center justify-content-between"
                        key={index}
                      >
                        <div
                          className="d-flex align-items-center product-info"
                          data-bs-toggle="modal"
                          data-bs-target="#products"
                        >
                          <div style={styles.productInfo} className="info">
                            <h6 style={styles.productTitle}>
                              <Link to="#">{item.label}</Link>
                            </h6>
                            <p
                              style={styles.productPrice}
                              className="text-info"
                            >
                              ₹{item.price}
                            </p>
                          </div>
                        </div>
                        <div className="qty-item text-center">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-minus">Minus</Tooltip>
                            }
                          >
                            <Link
                              to="#"
                              className="dec d-flex justify-content-center align-items-center"
                              onClick={() => handleDecrement(index)}
                            >
                              <MinusCircle className="feather-14" />
                            </Link>
                          </OverlayTrigger>
                          <input
                            type="text"
                            className="form-control text-center"
                            name="qty"
                            value={item.quantity}
                            readOnly
                          />
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-plus">Plus</Tooltip>}
                          >
                            <Link
                              to="#"
                              onClick={() => handleIncrement(index)}
                              className="inc d-flex justify-content-center align-items-center"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="plus"
                            >
                              <PlusCircle className="feather-14" />
                            </Link>
                          </OverlayTrigger>
                        </div>
                        <div className="d-flex align-items-center action">
                          <Link
                            onClick={() => showConfirmationAlert(index)}
                            className="btn-icon delete-icon confirm-text"
                            to="#"
                          >
                            <Trash2 className="feather-14" />
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="block-section">
                  <div className="selling-info">
                    <div className="row">
                      <div className="col-12 col-sm-6">
                        <div className="input-block">
                          <label>Discount Type</label>
                          <Select
                            className="select"
                            options={discountType}
                            placeholder="Type"
                            onChange={handleDiscountTypeChange}
                          />
                        </div>
                      </div>
                      <div
                        className={`col-12 col-sm-6 ${
                          selectedDisType == 2 ? "d-block" : "d-none"
                        }`}
                      >
                        <div className="input-block">
                          <label>Discount</label>
                          <Select
                            className="select"
                            options={discount}
                            placeholder="Choose"
                            onChange={handleDiscountPercChange}
                          />
                        </div>
                      </div>
                      <div
                        className={`col-12 col-sm-6 ${
                          selectedDisType == 1 ? "d-block" : "d-none"
                        }`}
                      >
                        <div className="input-block">
                          <label>Discount</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter amount"
                            onChange={(e) => setDiscountAmount(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="order-total">
                    <table className="table table-responsive table-borderless">
                      <tbody>
                        <tr>
                          <td>Sub Total</td>
                          <td className="text-end">
                            ₹{amounts.subtotal.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Tax</td>
                          <td className="text-end">
                            ₹{amounts.totalTax.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
  <td>Subtotal (after auto disc)</td>
  <td>₹{amounts.subtotal.toFixed(2)}</td>
</tr>
{amounts.autoDiscountTotal > 0 && (
  <tr className="text-danger">
    <td>Auto Discounts</td>
    <td>-₹{amounts.autoDiscountTotal.toFixed(2)}</td>
  </tr>
)}
<tr>
  <td>Manual Discount{discountPerc ? ` (${discountPerc}%)` : ""}</td>
  <td className="text-danger">-₹{amounts.manualDiscount.toFixed(2)}</td>
</tr>
                        <tr>
                          <td className="danger d-flex">
                            Discount{" "}
                            <span
                              className={`ms-1 ${
                                selectedDisType == 2 ? "d-block" : "d-none"
                              }`}
                            >
                              ({discountPerc}%)
                            </span>
                          </td>
                          <td className="danger text-end">
                            ₹{amounts.totalDiscount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Total</td>
                          <td className="text-end">
                            ₹{amounts.finalTotal.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="block-section payment-method">
                  <h6>Payment Method</h6>
                  <div className="row align-items-end">
                    <div className="col-sm-5">
                      <label>Payment Type</label>
                      <Select
                        className="select"
                        id="categorySelect"
                        onChange={handlePaymentTypeChange}
                        options={paymentTypes?.map((ptypes) => ({
                          value: ptypes.Id,
                          label: ptypes.Name,
                        }))}
                        value={selectedPaymentTypeOption}
                        placeholder="Choose type"
                        isClearable={false}
                      />
                    </div>
                    {/* <div className="col-sm-5">
                      <label>Payment Amount</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        placeholder="Enter payment amount"
                        value={currentPaymentAmount}
                        onChange={(e) =>
                          setCurrentPaymentAmount(e.target.value)
                        }
                      />
                    </div> */}

                    {/* <div className="col-sm-5">
                      <label>Payment Amount</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        placeholder="Enter payment amount"
                        value={
                          currentPaymentAmount === ""
                            ? remainingAmount 
                            : currentPaymentAmount
                        }
                        onChange={(e) =>
                          setCurrentPaymentAmount(e.target.value)
                        }
                        onFocus={(e) => {
                          // Optional: Select all on focus for quick override
                          if (
                            currentPaymentAmount === "" ||
                            currentPaymentAmount === remainingAmount.toString()
                          ) {
                            e.target.select();
                          }
                        }}
                      />
                    </div> */}
                    <div className="col-sm-5">
                      <label>Payment Amount</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        placeholder="Enter payment amount"
                        value={
                          currentPaymentAmount === ""
                            ? remainingAmount.toFixed(2) // Always show 2 decimals when auto-filled
                            : currentPaymentAmount
                        }
                        onChange={(e) =>
                          setCurrentPaymentAmount(e.target.value)
                        }
                        onFocus={(e) => {
                          // Select all when focusing if it's the auto-filled remaining amount
                          if (
                            currentPaymentAmount === "" ||
                            parseFloat(currentPaymentAmount) === remainingAmount
                          ) {
                            e.target.select();
                          }
                        }}
                        onBlur={(e) => {
                          // Optional: Clean up and format to 2 decimals when user leaves the field
                          const value = e.target.value;
                          if (value && !isNaN(value)) {
                            setCurrentPaymentAmount(
                              parseFloat(value).toFixed(2),
                            );
                          }
                        }}
                      />
                    </div>
                    <div className="col-sm-2">
                      <label>&nbsp;</label>
                      <button
                        className="btn btn-primary w-100"
                        onClick={handleAddPayment}
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  {payments.length > 0 && (
                    <div className="payment-list mt-3">
                      <h6>Added Payments</h6>
                      {payments.map((payment, index) => {
                        const paymentTypeName =
                          paymentTypes.find(
                            (pt) => pt.Id === payment.PaymentTypeId,
                          )?.Name || "Unknown";
                        return (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-1 p-1 border"
                          >
                            <span>
                              {paymentTypeName}: ₹
                              {payment.PaidAmount.toFixed(2)}
                            </span>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleRemovePayment(index)}
                            >
                              <Trash2 className="feather-14" />
                            </button>
                          </div>
                        );
                      })}
                      <hr />
                      <div className="d-flex justify-content-between">
                        <strong>Total Paid:</strong>{" "}
                        <strong>₹{totalPaid.toFixed(2)}</strong>
                      </div>
                      <div className="d-flex justify-content-between">
                        <strong>Remaining:</strong>{" "}
                        <strong>₹{remainingAmount.toFixed(2)}</strong>
                      </div>
                    </div>
                  )}
                </div>
              </aside>
            </div>
          </div>
        </div>
        <div
          className="col-4 pb-1"
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
        >
          <button className="btn btn-light mb-1 col-12">
            Grand Total : ₹{amounts?.finalTotal.toFixed(2)}
          </button>
          <div className="btn-row d-sm-flex align-items-center justify-content-between ">
            <Link
              to="#"
              className="btn btn-info btn-icon flex-fill"
              data-bs-toggle="modal"
              data-bs-target="#hold-order"
            >
              <span className="me-1 d-flex align-items-center">
                <i className="fas fa-pause-circle me-2"></i>
              </span>
              Hold
            </Link>
            <Link
              to="#"
              className="btn btn-danger btn-icon flex-fill"
              onClick={handleVoidScreen}
            >
              <span className="me-1 d-flex align-items-center">
                <i className="fas fa-trash-alt me-2"></i>
              </span>
              Void
            </Link>
            <button
              className="btn btn-success btn-icon flex-fill"
              onClick={handleSubmit}
            >
              <span className="me-1 d-flex align-items-center">
                {/* <i data-feather="credit-card" className="feather-16" /> */}
                <i className="fas fa-credit-card me-2"></i>
              </span>
              Payment
            </button>
          </div>
        </div>
      </div>
      {/* Payment Completed */}

      {/* /Payment Completed */}
      {/* Print Receipt */}

      {/* /Print Receipt */}

      {/* Hold */}
      <div
        className="modal fade modal-default pos-modal"
        id="hold-order"
        aria-labelledby="hold-order"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5>Hold order</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <form>
                <h2 className="text-center p-4">
                  ₹{amounts?.finalTotal.toFixed(2)}
                </h2>
                <div className="input-block">
                  <label>Order Reference</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue=""
                    placeholder=""
                  />
                </div>
                <p>
                  The current order will be set on hold. You can retreive this
                  order from the pending order button. Providing a reference to
                  it might help you to identify the order more quickly.
                </p>
                <div className="modal-footer d-sm-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <Link to="#" className="btn btn-primary">
                    Confirm
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Hold */}
      {/* Edit Product */}
      {/* Hidden area for printing */}
      <div style={{ display: "none" }}>
        <div
          ref={receiptRef}
          dangerouslySetInnerHTML={{ __html: receiptHtml }}
        />
      </div>

      <AddCustomerModal
        isOpen={isAddCustomerOpen}
        onClose={() => setIsAddCustomerOpen(false)}
        onCustomerAdded={refetchCustomers}
      />
    </>
  );
};
export default AddSale;
